import * as React from 'react';
import { connect } from 'react-redux';
import RoleListUI from './RoleList';
import { UserInfo, UserRole, Permission, RoleInfo } from '../../Login/common/defaults';
import {
	getRoleAdminInfo,
	saveRole
} from '../redux-objects/actions';

import { updateHeaderByComponent } from '../../Navigation/redux-objects/actions';
import { Modal, Button, Row } from 'react-bootstrap';
import ToggleSwitch, { ToggleStyle } from '../../shared/ToggleSwitch';

import * as urls from '../../shared/urls';
import moment from 'moment';
import { toast } from 'react-toastify';
import '../assets/styles.css';

export interface IRoleAdminPropsFromState {
	roles: RoleInfo[];
	permissions: Permission[];
	serviceURL: string;
	currentUser: UserInfo;
}

interface IRoleAdminPropsFromActions {
	getRoleAdminInfo: (url: string) => void;
	updateHeaderByComponent: (newNav: string) => void;
	saveRole: (url: string, role: RoleInfo) => Promise<void>;
}
interface IRoleAdminLocalState {
	roleToEdit: RoleInfo;
	isEditing: boolean;
	modalIsOpen: boolean;
}

type IRoleAdminProps = IRoleAdminPropsFromState & IRoleAdminPropsFromActions;

class UserAdministrationController extends React.Component<IRoleAdminProps, IRoleAdminLocalState> {
	PermissionGrid: any[];

	constructor(props) {
		super(props);
		this.state = {
			roleToEdit: null,
			isEditing: false,
			modalIsOpen: true
		};

		this.closeModal = this.closeModal.bind(this);
		this.handleToggleChange = this.handleToggleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentDidMount() {
		this.loadInitialData();
	}

	loadInitialData() {
		const { roles, serviceURL } = this.props;
		if (roles && this.props.roles.length === 0) {
			(async () => {
				this.props.getRoleAdminInfo(serviceURL + urls.GET_ROLE_ADMIN_INFO);
			})();
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		const { serviceURL } = this.props;
		const { roleToEdit } = this.state;
		this.props
			.saveRole(serviceURL + urls.UPDATE_ROLE, roleToEdit)
			.then(() => {
				toast.success('Saved!');
				this.setState({ isEditing: false });
			})
			.catch((error) => {
				toast.error("Error Saving");
			});


		this.closeModal();
		this.render();
	}

	hasValue(inVal) {
		return inVal !== 'undefined' && inVal.length > 0;
	}

	handleToggleChange(event) {
		const { toggleIndex, on } = event;
		const { roleToEdit } = this.state;
		if (on) {
			this.setState({
				roleToEdit: { ...roleToEdit, rolePermissions: [...roleToEdit.rolePermissions, { roleId: roleToEdit.id, permissionId: toggleIndex }] }
			});
		} else {
			const filteredRolePermissions = roleToEdit.rolePermissions.filter((rp) => rp.permissionId !== toggleIndex);
			this.setState({
				roleToEdit: { ...roleToEdit, rolePermissions: filteredRolePermissions }
			});
		}
	}

	closeModal() {
		this.props.updateHeaderByComponent('Role Administration > Role Administration');
		this.setState({ isEditing: false });
		this.exitEditing();
	}

	setSelectedRole = (id: number) => {
		this.setState({ roleToEdit: this.props.roles.find((item) => item.id == id), isEditing: true });
		this.props.updateHeaderByComponent('Role Administration > Assign Permissions');
	};

	exitEditing = () => {
		this.setState({ roleToEdit: null }); //, isEditing:false
		this.props.updateHeaderByComponent('Role Administration');
	};

	render() {

		const { roleToEdit } = this.state;

		const permissionToggles = this.state.roleToEdit && this.props.permissions && this.props.permissions.length > 0 && this.props.permissions.map((p) => {
			const { permissions } = this.props;
			const toggleOn =
				permissions &&
				roleToEdit &&
				roleToEdit.rolePermissions.find((rp) => rp.permissionId === p.id);
			return (
				<div key={p.id}>
					<ToggleSwitch
						on={toggleOn ? true : false}
						label={`${p.name}`}
						toggle={ToggleStyle.AllowedToEdit}
						toggleIndex={p.id}
						enabled={true}
						onChange={this.handleToggleChange}
					/>
				</div>
			);
		});

		return (
			<React.Fragment>
				{!this.state.isEditing && (
					<RoleListUI
						Roles={this.props.roles && this.props.roles.length > 0 ? this.props.roles : []}
						selectRoleToEdit={this.setSelectedRole}
					/>
				)}

				{this.state.isEditing && (
					<Modal
						dialogClassName="modal-fullscreen"
						show={this.state.isEditing ? this.state.isEditing : false}
						onHide={this.closeModal}
						size='lg'
					>
						<Modal.Header closeButton>
							<Modal.Title className="text-center">
								{`Assign ${roleToEdit.name} Permissions`}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Row className="row-cols-2 justify-content-between px-2">
								{permissionToggles}
							</Row>
							<Button variant="secondary" onClick={this.handleSubmit}>
								Assign Roles
							</Button>
							<Button variant="secondary" onClick={this.closeModal} className="float-right">
								Cancel
							</Button>
						</Modal.Body>
					</Modal>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (reduxState: any) => {
	return {
		roles: reduxState.Admin.roles,
		serviceURL: reduxState.Application.backendURL,
		permissions: reduxState.Admin.permissions,
		currentUser: reduxState.Application.currentUser
	};
};

const mapDispatchToProps = {
	getRoleAdminInfo,
	saveRole,
	updateHeaderByComponent
};

export default connect<IRoleAdminPropsFromState, IRoleAdminPropsFromActions>(mapStateToProps, mapDispatchToProps)(
	UserAdministrationController
);
